import { render } from "./FlowView.vue?vue&type=template&id=52160519&scoped=true&ts=true"
import script from "./FlowView.vue?vue&type=script&lang=ts"
export * from "./FlowView.vue?vue&type=script&lang=ts"

import "./FlowView.vue?vue&type=style&index=0&id=52160519&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52160519"]])

export default __exports__